import Link from "next/link";

import { breadcumbsLinksTracker } from "@containers/Layout/PageHeader/HeaderTracker";

import { FactsStructure } from "types/FactsStructure";
import { IAmStructureItem } from "types/IAmStructureItem";

type FactBreadcrumbsData = {
  url: string;
  text: string;
};
export const getFactsBreadCrumbsData = (
  factsStructure: FactsStructure,
  currentSlugs: string[]
): FactBreadcrumbsData[] => {
  let breadCrumbItems = new Array<FactBreadcrumbsData>();

  if (!factsStructure?.flatStructure?.length && !currentSlugs?.length) return [];
  else {
    breadCrumbItems.push({
      url: "/forsakringshandboken",
      text: "Försäkringshandboken",
    });
    for (const slug of currentSlugs) {
      let foundStructureItem = {} as IAmStructureItem;
      foundStructureItem = factsStructure?.flatStructure?.filter(
        (factsItem) => factsItem.slug === slug
      )[0];
      if (!foundStructureItem) return;

      breadCrumbItems.push({
        url: foundStructureItem?.url,
        text: foundStructureItem?.name,
      });
    }
  }

  return breadCrumbItems;
};

export const getFactsStructureBreadCrumbs = (factBreadcrumbs: FactBreadcrumbsData[]): any[] => {
  let breadCrumbItems = [];

  factBreadcrumbs?.map((factBreadcrumb, index) =>
    breadCrumbItems.push(
      <Link
        href={`${factBreadcrumb?.url}`}
        prefetch={false}
        onClick={() => breadcumbsLinksTracker(factBreadcrumb?.text, "Utbildning och material")}
        aria-current={index === factBreadcrumbs?.length - 1 ? "page" : undefined}
      >
        {factBreadcrumb?.text}
      </Link>
    )
  );

  return breadCrumbItems;
};
